module.exports = __webpack_public_path__ + "static/media/HONEY.e256aec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HONEY.jpg
// module id = 140
// module chunks = 0